import { VisitDetails } from "src/api/session";
import { DomainInfo } from "src/api/domainInfo";

/**
 * Log DOM changes - sends each change individually to the backend (fire-and-forget)
 * @param session User session
 * @param domain Domain info
 * @param changes Array of DOM changes (each will be sent as a separate request)
 */
export const LogDomChanges = ({
    visitDetails,
    domain,
    changes,
}: {
    visitDetails: VisitDetails;
    domain: DomainInfo;
    changes: string[];
}): void => {
    // Send each change as a separate request (fire-and-forget)
    changes.forEach((change) => {
        try {
            // Validate change size before sending (prevent string overflow)
            const MAX_CHANGE_SIZE = 50000; // 50KB limit per change
            if (change.length > MAX_CHANGE_SIZE) {
                // eslint-disable-next-line no-console
                console.warn(
                    `Change too large (${change.length} chars), truncating to ${MAX_CHANGE_SIZE}`,
                );
                change =
                    change.substring(0, MAX_CHANGE_SIZE) + "... [TRUNCATED]";
            }

            const payload = {
                data: {
                    change,
                    visitId: visitDetails.visitId,
                    platform: visitDetails.platform,
                    trafficSourceNetwork: visitDetails.trafficSourceNetwork,
                    trafficSource: visitDetails.trafficSource,
                    url: window.location.href,
                    domainName: domain.name,
                    domainId: domain.id,
                    source: "dom-changes",
                },
            };

            // Try to stringify to validate size before sending
            const payloadString = JSON.stringify(payload);
            if (payloadString.length > 100000) {
                // 100KB limit for entire payload
                // eslint-disable-next-line no-console
                console.error(
                    `Payload too large (${payloadString.length} chars), skipping`,
                );
                return;
            }

            void fetch(`/api/log-dom-changes`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-DOMAIN-NAME": domain.name,
                },
                body: payloadString,
            });
        } catch (error) {
            // Silently catch any JSON.stringify errors or other issues
            // eslint-disable-next-line no-console
            console.error("Error scan change:", error);
        }
    });
};
